import * as React from 'react';
import { t } from 'i18next';

import { AjaxErrorHandler } from '../utils/AjaxErrorHandler';

interface ConnectionErrorProps {
    sidebarOpen: boolean;
}

export class ConnectionError extends React.PureComponent<ConnectionErrorProps> {
    public render(): JSX.Element {
        return (
            <div className={'connection-error' + (this.props.sidebarOpen ? ' connection-error-sidebar' : '')}>
                <div className="connection-error-label">{t('Connection to server failed.')}</div>
                <div className="connection-reconnect" onClick={AjaxErrorHandler.retryNetworkRequests}>{t('Please, try again.')}&nbsp;&raquo;</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ConnectionError.tsx